var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-item"},[_c('img',{attrs:{"src":require('./images/' + _vm.itemData.img),"width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }